import * as angular from 'angular';

import {
    ComponentDefinition,
    IDateDateRange,
    LogbookEntryDto,
    SeriesDefinition,
    TagDateValue,
    WidgetValues,
} from '../../models';
import {
    IExportToCsvService,
    ILogbookService,
    ITagsTrendService,
} from '../../services';
import {
    IAlarmHelper,
    wtTrendSelection,
} from '../../common';
import { TagsTrendWidget } from '../../widgets/tagsTrend/tagsTrend.widget';
import {
    lineChartLeftMargin,
    IChartOptions,
} from '../../framework';
import moment = require('moment');

class BoundTagsTrendController implements angular.IComponentController {
    data: TagDateValue[];
    item: TagsTrendWidget;
    margins: IChartOptions;
    options: any;
    rootData: any;
    // used just to detect change, plz do not use
    stringOptions: string;

    readonly boundData: WidgetValues;
    readonly ratio: number;
    readonly series: SeriesDefinition<TagDateValue>[];

    private _garbages: (() => void)[] = [];

    static $inject = [
        '$scope',
        'tagsTrendService',
        'exportToCsvService',
        'alarmHelper',
        'logbookService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _tagsTrendService: ITagsTrendService,
        private _exportToCsvService: IExportToCsvService,
        private _alarmHelper: IAlarmHelper,
        private _logbookService: ILogbookService
    ) {
    }

    $onInit() {
        if (this.item) {
            this.item.exportToCsv = () => this._exportToCsvService.exportToCsv(this.series, this.data, this.item.name);
        }

        this._$scope.$watch(
            () => this.options.crosshairDate,
            (newValue) => this.item.configuration.options.crosshairDate = newValue
        );
        this._$scope.$watch(
            () => this.item.configuration.options.crosshairDate,
            (newValue) => this.options.crosshairDate = newValue
        );

        this._$scope.$on(wtTrendSelection, (_: angular.IAngularEvent, data: IDateDateRange) => {
            this.onSelection(data);
        });
    }

    $onDestroy() {
        this._garbages.forEach(w => w());
    }

    $onChanges(changes: angular.IOnChangesObject) {
        if (this.item && this.item.configuration) {
            this.updateConfiguration();
        }
        if (changes['series'] && changes['series'].currentValue) {
            this.updateSeries(changes['series'].currentValue);

        }
        if (changes['boundData'] && changes['boundData'].currentValue && this.series) {
            this.updateBoundData(changes['boundData'].currentValue);
        }
        if (changes['ratio'] && this.ratio) {
            this.updateRatio();
        }
    }

    private updateConfiguration(): void {
        const newOptions = this._tagsTrendService.getOptions(this.item);
        const strNewOptions = JSON.stringify(newOptions);
        // smarter handle of update if no change
        if (strNewOptions !== this.stringOptions) {
            this.stringOptions = strNewOptions;
            this.options = newOptions;
        }
    }

    private updateSeries(series: SeriesDefinition<TagDateValue>[]): void {
        if (this.options.panes) {
            if (this.series && this.item.configuration.showAlarms) {
                this.options.panes[0].horizontalLines = this._alarmHelper.getHorizontalLines(series);
            } else {
                this.options.panes[0].horizontalLines = [];
            }
            this.options.panes[0].areas = this._tagsTrendService.getEntryPanes(this.filterEntries());
        }
    }

    private updateBoundData(boundData: WidgetValues): void {
        const data = this._tagsTrendService.getValues(this.item.configuration, boundData);
        if (data) {
            this.data = data.data;
            this.options.display.xRange = [data.range.beginDate, data.range.endDate];
            if (this.options.panes) {
                let panes: any[] = this._tagsTrendService.getEntryPanes(this.filterEntries());
                panes.filter(p => !p.endDate).forEach(p => p.endDate = data.range.endDate);
                if (this.series && this.item.configuration.showAlarms) {
                    this.series
                        .filter(s => s.alarms && s.alarms.length)
                        .forEach(s => {
                            const filtered = this.data.filter(d => d.valueType + d.guid === s.identifier);
                            const areas = this._alarmHelper.getAlarmAreas(filtered, data.range.endDate.toISOString(), s.alarms);
                            panes = panes.concat(areas);
                        });
                }
                this.options.panes[0].areas = panes;
            }
        }
    }

    private updateRatio(): void {
        this.margins = {
            translateX: lineChartLeftMargin * this.ratio,
            translateY: 10 * this.ratio,
            translateTop: 0,
            translateBottom: lineChartLeftMargin * this.ratio
        };
    }

    private filterEntries(): LogbookEntryDto[] {
        if (!this.boundData || !this.series) {
            return [];
        }
        const entries = this.boundData.entries;
        // #27151 : filtering is now handled in backend
        // if (entries && entries.length) {
        //     const identifiers = this.series.map(s => s.identifier);
        //     const filteredEntries = entries.filter(e => e.identifier && identifiers.filter(i => i.indexOf(e.identifier.guid) >= 0).length);
        //     return filteredEntries;
        // }
        return entries || [];
    }

    private onSelection(dates: IDateDateRange): void {
        const series = this.item?.configuration?.series;
        if (series?.length > 0) {
            let guid = series[0].guid;
            if (this.item && this.item.map && this.item.map[guid]) {
                guid = this.item.map[guid];
            }
            this._logbookService.openModal(
                guid,
                { severity: 0 },
                false,
                true,
                true,
                { startDate: dates.beginDate.toISOString(), endDate: dates.endDate.toISOString() }
            );
        }
    }
}

export const wtBoundTagsTrend: ComponentDefinition = {
    componentId: 'wtBoundTagsTrend',
    controller: BoundTagsTrendController,
    template: require('./boundTagsTrend.component.html'),
    controllerAs: 'vm',
    bindings: {
        alarmList: '<?',
        series: '<',
        boundData: '<',
        item: '=',
        ratio: '<?'
    }
};